exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.is-invalid[data-v-64ee0390] {\r\n  border: 1px solid red !important;\r\n  border-radius: 4px;\n}\n.truncate[data-v-64ee0390] {\r\n  display: inline-block;\r\n  max-width: 150px;\r\n  overflow: hidden;\r\n  white-space: nowrap;\r\n  text-overflow: ellipsis;\n}\n#custom-table[data-v-64ee0390] {\r\n  font-family: none;\n}\r\n", ""]);

// exports
